import index from "@/pages/candidateAuth/index.vue";
export default {
    path: "/candidateAuth",
    name: "candidateAuth",
    component: index,
    meta: { title: "人才授权" },
    redirect: '/candidateAuth/index',
    children: [{
            path: 'index',
            name: 'index',
            component: () =>
                import (
                    /* webpackChunkName: "activity" */
                    '@/pages/candidateAuth/views/index.vue'
                ),
            meta: {
                title: '禾蛙活动专区',
            },
        },
        {
            path: "authInvite",
            name: "authInvite",
            component: () =>
                import (
                    /* webpackChunkName: "preach" */
                    "@/pages/candidateAuth/views/authInvite.vue"
                ),
            meta: { title: "邀请授权" },
        },
        {
            path: "enterConfirmCode",
            name: "enterConfirmCode",
            component: () =>
                import (
                    /* webpackChunkName: "preach" */
                    "@/pages/candidateAuth/views/enterConfirmCode.vue"
                ),
            meta: { title: "输入验证码" },
        },
        {
            path: "authLetter",
            name: "authLetter",
            component: () =>
                import (
                    /* webpackChunkName: "preach" */
                    "@/pages/candidateAuth/views/authLetter.vue"
                ),
            meta: { title: "授权书" },
        },
        {
            path: "authSuccess",
            name: "authSuccess",
            component: () =>
                import (
                    /* webpackChunkName: "preach" */
                    "@/pages/candidateAuth/views/authSuccess.vue"
                ),
            meta: { title: "授权成功" },
        },
        {
            path: "downloadAuthLetter",
            name: "downloadAuthLetter",
            component: () =>
                import (
                    /* webpackChunkName: "preach" */
                    "@/pages/candidateAuth/views/downloadAuthLetter.vue"
                ),
            meta: { title: "下载授权书" },
        },
        {
            path: "authed",
            name: "authed",
            component: () =>
                import (
                    /* webpackChunkName: "preach" */
                    "@/pages/candidateAuth/views/authed.vue"
                ),
            meta: { title: "已完成授权" },
        },
        {
            path: "infoVerify",
            name: "infoVerify",
            component: () =>
                import (
                    /* webpackChunkName: "preach" */
                    "@/pages/candidateAuth/views/infoVerify.vue"
                ),
            meta: { title: "查询授权记录" },
        },
        {
            path: "unauth",
            name: "unauth",
            component: () =>
                import (
                    /* webpackChunkName: "preach" */
                    "@/pages/candidateAuth/views/unauth.vue"
                ),
            meta: { title: "暂未授权" },
        },
        {
            path: "authReject",
            name: "authReject",
            component: () =>
                import (
                    /* webpackChunkName: "preach" */
                    "@/pages/candidateAuth/views/authReject.vue"
                ),
            meta: { title: "拒绝授权" },
        },
        {
            path: "authCancel",
            name: "authCancel",
            component: () =>
                import (
                    /* webpackChunkName: "preach" */
                    "@/pages/candidateAuth/views/authCancel.vue"
                ),
            meta: { title: "取消授权成功" },
        },
        {
            path: "incorrectAuthInfo",
            name: "incorrectAuthInfo",
            component: () =>
                import (
                    /* webpackChunkName: "preach" */
                    "@/pages/candidateAuth/views/incorrectAuthInfo.vue"
                ),
            meta: { title: "邀请信息有误" },
        },
    ],
};